import { Flex, Text } from '@chakra-ui/react';

import { OutlineCard } from '@morressier/alembic';
import EditProfileModal from './EditProfileModal';
import { RenderSectionDetails } from './RenderSectionDetails';
import { IUserType } from '../UserRegistrationSteps/StepThree/signupHook';

export type IUserProfileDetailsType = {
  phoneNumber?: string;
  linkedinProfileUrl?: string;
  countryCallingCode?: string;
  countryCode?: string;
};
const ProfileDetails = ({
  organizationId,
  data
}: {
  organizationId: string;
  data: {
    user: IUserType;
    profileDetails: IUserProfileDetailsType;
  };
}) => {
  const fullPhoneNumber = data?.profileDetails?.phoneNumber
    ? `+${data?.profileDetails?.countryCallingCode}${data?.profileDetails?.phoneNumber}`
    : '';

  return (
    <Flex direction="column" width="100%" gap={3}>
      <Flex align={'center'} justifyContent={'space-between'}>
        <Text textStyle="headingGroup">Profile Details</Text>
        <EditProfileModal organizationId={organizationId} data={data} />
      </Flex>

      <OutlineCard width="100%" padding={4}>
        <Flex direction={'column'} gap={3}>
          <RenderSectionDetails
            label="ORCID iD"
            value={data?.user?.orcid ?? ''}
            type="orcid"
          />
          <RenderSectionDetails
            label="Secondary Email"
            value={data?.user?.secondaryEmail ?? ''}
          />
          <RenderSectionDetails
            label="CC Email"
            value={data?.user?.ccEmail ?? ''}
          />
          <RenderSectionDetails
            label="Additional Emails"
            value={data?.user?.additionalEmails}
            type="bullet"
          />
          <RenderSectionDetails
            label="Professional Degree"
            value={data?.user?.degree ?? ''}
          />
          <RenderSectionDetails
            label="Job Title"
            value={data?.user?.jobTitle ?? ''}
          />
          <RenderSectionDetails
            label="Phone Number"
            value={fullPhoneNumber || ''}
          />

          <RenderSectionDetails
            label="LinkedIn Profile URL"
            value={data.profileDetails?.linkedinProfileUrl ?? ''}
            type="url"
          />
        </Flex>
      </OutlineCard>
    </Flex>
  );
};

export default ProfileDetails;
